import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { JSX } from 'react';
import InnerContent from './InnerContent/InnerContent';

export type AdvantagesOfHelocProps =
  SliceComponentProps<Content.AdvantagesOfHelocSlice>;

const AdvantagesOfHeloc = ({ slice }: AdvantagesOfHelocProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
    >
      <InnerContent slice={slice.primary} />
    </section>
  );
};

export default AdvantagesOfHeloc;
